const FONT = "Inter, 'Helvetica Neue', Arial, sans-serif";
const GOLD = "#d4a017";

/** 1080x1080 "Guess the Year" streak card: today's score, the streak and the headline/page that was guessed. */
export function drawStreakCard(canvas, { score, streak, year, guess, text, kind, dateLabel, revealed }) {
  const S = 1080;
  canvas.width = S; canvas.height = S;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#111827"; ctx.fillRect(0, 0, S, S);
  ctx.fillStyle = GOLD; ctx.fillRect(0, 0, S, 14); ctx.fillRect(0, S - 14, S, 14);
  ctx.textAlign = "center"; ctx.textBaseline = "middle";
  ctx.fillStyle = GOLD; ctx.font = `700 30px ${FONT}`; ctx.letterSpacing = "8px";
  ctx.fillText("GUESS THE YEAR", S / 2, 110); ctx.letterSpacing = "0px";
  ctx.fillStyle = "#9ca3af"; ctx.font = `500 30px ${FONT}`; ctx.fillText(dateLabel, S / 2, 165);
  ctx.fillStyle = "#fff"; ctx.font = `800 260px ${FONT}`; ctx.fillText(revealed ? "👀" : `+${score}`, S / 2, 360);
  ctx.fillStyle = "#e5e7eb"; ctx.font = `600 40px ${FONT}`;
  ctx.fillText(revealed ? "I peeked at the answer today" : score === 100 ? "Spot on!" : score >= 80 ? "One year out" : score >= 60 ? "Within three years" : score >= 40 ? "Within five years" : score >= 20 ? "Within a decade" : "Way off — history is sneaky", S / 2, 520);
  ctx.strokeStyle = GOLD; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(200, 590); ctx.lineTo(S - 200, 590); ctx.stroke();
  ctx.fillStyle = "#9ca3af"; ctx.font = `500 30px ${FONT}`;
  ctx.fillText(`${kind === "clipping" ? "The newspaper page" : "The headline"} was from ${year}${guess ? ` · I said ${guess}` : ""}`, S / 2, 650);
  ctx.fillStyle = "#fff"; ctx.font = `italic 600 36px ${FONT}`;
  const words = String(text || "").split(" "); const lines = []; let line = "";
  words.forEach((w) => { const t = line ? `${line} ${w}` : w; if (ctx.measureText(t).width > S - 200 && line) { lines.push(line); line = w; } else line = t; });
  if (line) lines.push(line);
  lines.slice(0, 2).forEach((l, i) => ctx.fillText(i === 1 && lines.length > 2 ? `${l}…` : l, S / 2, 720 + i * 48));
  ctx.fillStyle = GOLD; ctx.font = `800 64px ${FONT}`; ctx.fillText(`🔥 ${streak}-day streak`, S / 2, 880);
  ctx.fillStyle = "#9ca3af"; ctx.font = `600 30px ${FONT}`; ctx.fillText("Play today's challenge · oddlytrue.co", S / 2, 990);
}

export async function downloadStreakCard(opts) {
  const canvas = document.createElement("canvas");
  drawStreakCard(canvas, opts);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = `oddlytrue-guess-the-year-${opts.dateLabel.replace(/\s+/g, "-").toLowerCase()}.png`; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
